// @flow

import React from 'react';
import { Menu, Icon, Dropdown } from 'semantic-ui-react';
import ResourcesPager from './ResourcesPager';
import FoldersFilter from './FoldersFilter';
import DebounceInput from 'react-debounce-input';

type Props = {
  folders: List<BucketFolder>,
  hasPreviousPage: boolean,
  hasNextPage: boolean,
  isCreating: boolean,
  onPreviousPage: () => void,
  onNextPage: () => void,
  currentFolder?: number,
  onFolderChange: (folder: number) => void,
  currentFilter: string,
  onFilterChange: (filter: string) => void,
  onCreate: (folderId: string) => void,
};

const ResourcesHeader = ({
  folders,
  hasPreviousPage,
  hasNextPage,
  isCreating,
  onPreviousPage,
  onNextPage,
  currentFolder,
  onFolderChange,
  currentFilter,
  onFilterChange,
  onCreate,
}: Props) => {
  const changeFilter = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      onFilterChange(event.target.value);
    } else {
      onFilterChange('');
    }
  };

  const moveCaretAtEnd = (e: SyntheticEvent) => {
    if (e.target instanceof HTMLInputElement) {
      var temp_value = e.target.value;
      e.target.value = '';
      e.target.value = temp_value;
    }
  };

  const createResource = folderId => () => onCreate(folderId);

  return (
    <Menu>
      <Menu.Item>
        <div className="ui icon input">
          <DebounceInput
            autoFocus
            minLength={2}
            debounceTimeout={600}
            value={currentFilter}
            onChange={changeFilter}
            onFocus={moveCaretAtEnd}
            placeholder="Recherche..."
          />
          <Icon name="search" />
        </div>
      </Menu.Item>
      <Menu.Item>
        <FoldersFilter
          value={currentFolder}
          folders={folders}
          onChange={onFolderChange}
        />
      </Menu.Item>
      <Menu.Menu position="right">
        <Menu.Item>
          <ResourcesPager
            hasPrevious={hasPreviousPage}
            hasNext={hasNextPage}
            onPrevious={onPreviousPage}
            onNext={onNextPage}
          />
        </Menu.Item>
        {folders.size > 0 && (
          <Menu.Item>
            <Dropdown
              text="Ajouter au dossier"
              icon="add"
              floating
              loading={isCreating}
              labeled
              button
              className="icon"
            >
              <Dropdown.Menu>
                <Dropdown.Header
                  icon="folder"
                  content="Sélectionnez un dossier"
                />
                <Dropdown.Menu scrolling>
                  {folders
                    .toArray()
                    .map(f => (
                      <Dropdown.Item
                        key={f.id}
                        value={f.id}
                        text={f.name}
                        onClick={createResource(f.id)}
                      />
                    ))}
                </Dropdown.Menu>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        )}
      </Menu.Menu>
    </Menu>
  );
};

export default ResourcesHeader;



// WEBPACK FOOTER //
// ./src/shared/components/ResourceSelector/components/ResourcesHeader.js